import React from "react";
import { Row } from "../_ui";

export default function MarketDataPanel({ form, setField }) {
  return (
    <>
      <Row label="Enable market data">
        <label className="inline-flex items-center gap-2 cursor-pointer">
          <input
            type="checkbox"
            checked={form.market_data_enabled}
            onChange={(e) => setField("market_data_enabled", e.target.checked)}
            data-testid="sitedetail-market-data-enabled"
          />
          <span className="text-sm">{form.market_data_enabled ? "ON — live quotes refresh every 5 minutes" : "OFF"}</span>
        </label>
      </Row>
      {form.market_data_enabled && (
        <>
          <Row label="Running ticker">
            <label className="inline-flex items-center gap-2 cursor-pointer">
              <input
                type="checkbox"
                checked={form.market_data_ticker}
                onChange={(e) => setField("market_data_ticker", e.target.checked)}
                data-testid="sitedetail-market-ticker"
              />
              <span className="text-sm">{form.market_data_ticker ? "ON — animated quote strip below header" : "OFF"}</span>
            </label>
          </Row>
          <Row label="Sidebar widget">
            <label className="inline-flex items-center gap-2 cursor-pointer">
              <input
                type="checkbox"
                checked={form.market_data_sidebar}
                onChange={(e) => setField("market_data_sidebar", e.target.checked)}
                data-testid="sitedetail-market-sidebar"
              />
              <span className="text-sm">{form.market_data_sidebar ? "ON — simple list widget on layouts with a sidebar (Magazine + Mainframe)" : "OFF"}</span>
            </label>
          </Row>
          <Row label="Symbols">
            <div className="space-y-2">
              <input
                value={form.market_data_symbols}
                onChange={(e) => setField("market_data_symbols", e.target.value)}
                placeholder="SPY,DIA,QQQ,IWM,AAPL,MSFT,NVDA,TSLA,GOOGL,BINANCE:BTCUSDT,BINANCE:ETHUSDT"
                data-testid="sitedetail-market-symbols"
                className="admin-input w-full bg-transparent border border-zinc-800 px-3 py-2 rounded-sm text-sm mono"
              />
              <div className="text-[11px] text-zinc-500 mono leading-relaxed">
                CSV of Finnhub symbols. Leave blank for the default mix (indices + mega caps + BTC/ETH).<br />
                Examples: <code>SPY</code> S&amp;P 500 · <code>DIA</code> Dow · <code>QQQ</code> Nasdaq · <code>AAPL</code> stocks ·{" "}
                <code>BINANCE:BTCUSDT</code> Bitcoin · <code>GLD</code> Gold · <code>TLT</code> 20Y Treasury.
              </div>
            </div>
          </Row>
        </>
      )}
    </>
  );
}
